module.exports = __webpack_public_path__ + "img/alan_h.cf523f60.jpg";